/* ==========================================================================
   Putter Golf : modules interactifs des sections pg-* et de l'aide technique des fiches produit.
   JavaScript sans bibliothèque. Chaque outil est un bloc [data-pg-calc="..."] autonome :
     len   longueur de club et lie (taille + distance poignet-sol)
     flex  flex du manche (vitesse de swing au driver ou distance de carry)
     putt  longueur de putter (taille + posture)
     pf    choix du putter (trajectoire, visuel, ressenti, main, taille)
     batt  capacité de batterie lithium d'un chariot (trous, relief, type, sorties)
     cart  voiturette : nombre de places selon l'usage
     ball  balle selon la vitesse de swing
   Les liens des résultats se lisent dans les attributs data-l-<clé> du bloc (réglables dans l'éditeur).
   Toutes les recommandations sont indicatives : elles s'affinent par un essai.
   ========================================================================== */
(function () {
  'use strict';
  var doc = document.documentElement;
  if (doc.className.indexOf('pg-js') < 0) doc.className += ' pg-js';
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Outils ---------- */
  function $(el, sel) { return el.querySelector(sel); }
  function $$(el, sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }
  function fr(n, d) { return Number(n).toFixed(d === undefined ? 0 : d).replace('.', ','); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function num(v) { if (v === null || v === undefined) return NaN; return parseFloat(String(v).replace(',', '.')); }
  function val(root, name) {
    var r = $(root, '[data-pg-in="' + name + '"]:checked');
    if (r) return r.value;
    var el = $(root, '[data-pg-in="' + name + '"]:not([type="radio"])');
    return el ? el.value : '';
  }
  function link(root, key, def) { return root.getAttribute('data-l-' + key) || def; }
  function idx(v, bounds) { for (var i = 0; i < bounds.length; i++) { if (v < bounds[i]) return i; } return bounds.length; }
  function inch(v) { return v % 1 ? fr(v, 1) : fr(v, 0); }
  function cm(inches) { return fr(inches * 2.54, 1); }
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function result(o) {
    var h = '';
    if (o.label) h += '<span class="pg-result__label">' + esc(o.label) + '</span>';
    if (o.big) h += '<strong class="pg-result__big">' + esc(o.big) + '</strong>';
    if (o.gauge !== undefined) {
      h += '<div class="pg-gauge" aria-hidden="true"><i style="left:' + Math.max(2, Math.min(98, o.gauge)) + '%"></i>';
      (o.marks || []).forEach(function (m) { h += '<b style="left:' + m[0] + '%">' + esc(m[1]) + '</b>'; });
      h += '</div>';
    }
    if (o.kv && o.kv.length) {
      h += '<dl class="pg-kv">';
      o.kv.forEach(function (p) { h += '<div><dt>' + esc(p[0]) + '</dt><dd>' + esc(p[1]) + '</dd></div>'; });
      h += '</dl>';
    }
    (o.p || []).forEach(function (t) { h += '<p>' + esc(t) + '</p>'; });
    var ctas = (o.ctas || []).filter(function (c) { return c && c[1]; });
    if (ctas.length) {
      h += '<div class="pg-result__ctas">';
      ctas.forEach(function (c, i) {
        h += '<a class="pg-btn ' + (i === 0 ? 'pg-btn--primary' : 'pg-btn--ghost') + '" href="' + esc(c[1]) + '"><span>' + esc(c[0]) + '</span>' + ARROW + '</a>';
      });
      h += '</div>';
    }
    return h;
  }
  function show(root, html, err) {
    var out = $(root, '[data-pg-out]'), e = $(root, '[data-pg-err]');
    if (e) { e.hidden = !err; if (err) e.textContent = err; }
    if (!out) return;
    if (html) { out.innerHTML = html; out.hidden = false; } else { out.hidden = true; }
  }

  /* ---------- (a) Longueur de club et (d) lie ----------
     Source : tableau statique de fitting « taille × distance poignet-sol » couramment publié par les fabricants
     de clubs (lignes = tranches de taille, colonnes = tranches de distance poignet-sol, valeurs = ajustement
     de longueur en pouces par rapport à la longueur standard). Repris ici en centimètres et arrondi au demi-pouce.
     Le lie suit le même tableau : petite taille et mains basses = lie plus plat, grande taille et mains hautes =
     lie plus droit. Hors des tranches du tableau, la recommandation est bornée et un essai est conseillé. */
  var LEN_H = [158, 165, 172, 180, 188, 195];          // bornes hautes des tranches de taille (cm)
  var LEN_W = [74, 79, 84, 89, 94, 99];                // bornes hautes des tranches poignet-sol (cm)
  var LEN_T = [                                        // ajustement (pouces) : ligne = taille, colonne = poignet-sol
    [-1, -1, -0.5, -0.5, 0, 0, 0],
    [-1, -0.5, -0.5, 0, 0, 0.5, 0.5],
    [-1, -0.5, 0, 0, 0.5, 0.5, 1],
    [-0.5, -0.5, 0, 0, 0.5, 0.5, 1],
    [-0.5, 0, 0, 0.5, 0.5, 1, 1],
    [0, 0, 0.5, 0.5, 1, 1, 1],
    [0, 0.5, 0.5, 1, 1, 1, 1]
  ];
  // Longueurs standard courantes (pouces) : fer 7 et driver, clubs homme et femme
  var STD = { h: { iron: 37, driver: 45.5 }, f: { iron: 36, driver: 44 } };

  function adjLabel(a) {
    if (a === 0) return 'Longueur standard';
    return (a > 0 ? '+' : '−') + inch(Math.abs(a)) + ' pouce' + (Math.abs(a) > 1 ? 's' : '') + ' (' + (a > 0 ? '+' : '−') + cm(Math.abs(a)) + ' cm)';
  }
  function calcLen(root) {
    var h = num(val(root, 'h')), w = num(val(root, 'w')), sex = val(root, 'sex') || 'h';
    if (isNaN(h) && isNaN(w)) { show(root, '', ''); return; }
    if (isNaN(h) || isNaN(w) || h < 120 || h > 215 || w < 55 || w > 115) {
      show(root, '', 'Indiquez une taille entre 120 et 215 cm et une distance poignet-sol entre 55 et 115 cm.');
      return;
    }
    var hi = idx(h, LEN_H), wi = idx(w, LEN_W), a = LEN_T[hi][wi];
    var lieScore = hi + wi - 6, lie;
    if (lieScore <= -3) lie = 'Plutôt plat (environ 2° flat)';
    else if (lieScore === -2) lie = 'Légèrement plat (environ 1° flat)';
    else if (lieScore >= 3) lie = 'Plutôt droit (environ 2° upright)';
    else if (lieScore === 2) lie = 'Légèrement droit (environ 1° upright)';
    else lie = 'Standard';
    var s = STD[sex] || STD.h;
    var p = ['Ajustement calculé d\'après le tableau de fitting taille × poignet-sol. Le lie se confirme par un test sur planche : la trace laissée sous la semelle doit être centrée.'];
    if (h < 150 || h > 200 || w < 70 || w > 104) p.unshift('Vos mesures sortent des tranches habituelles du tableau : un fitting avec essai est vivement conseillé.');
    show(root, result({
      label: 'Votre longueur de club',
      big: adjLabel(a),
      kv: [
        ['Fer 7 conseillé', inch(s.iron + a) + ' po (' + cm(s.iron + a) + ' cm)'],
        ['Driver conseillé', inch(s.driver + a) + ' po (' + cm(s.driver + a) + ' cm)'],
        ['Lie indicatif', lie]
      ],
      p: p,
      ctas: [['Voir les séries de fers', link(root, 'irons', '/collections/series-de-fers')],
             ['Tous les clubs', link(root, 'clubs', '/collections/clubs-de-golf')],
             [root.getAttribute('data-l-page') ? 'Guide du fitting' : '', link(root, 'page', '')]]
    }));
  }

  /* ---------- (b) Flex du manche ----------
     Plages usuelles de vitesse de swing au driver publiées par les fabricants de manches :
     Ladies < 75 mph, Senior (A) 75-84, Regular 85-94, Stiff 95-104, X-Stiff >= 105 mph (1 mph = 1,609 km/h).
     Distance de carry au driver correspondante (environ 2,4 m par mph au-delà de l'élan de départ) :
     < 165 m, 165-184 m, 185-209 m, 210-234 m, >= 235 m. */
  var FLEX = [
    { n: 'Ladies (L)', mph: 'moins de 75 mph', kmh: 'moins de 121 km/h', carry: 'moins de 165 m', t: 'Manche très souple : il aide à faire monter la balle et à gagner de la distance avec un swing doux.' },
    { n: 'Senior (A)', mph: '75 à 84 mph', kmh: '121 à 136 km/h', carry: '165 à 184 m', t: 'Manche souple : pour un swing posé, il apporte de la hauteur et de la distance sans forcer.' },
    { n: 'Regular (R)', mph: '85 à 94 mph', kmh: '137 à 152 km/h', carry: '185 à 209 m', t: 'Le flex le plus joué par les golfeurs amateurs : un bon équilibre entre tolérance, hauteur et contrôle.' },
    { n: 'Stiff (S)', mph: '95 à 104 mph', kmh: '153 à 168 km/h', carry: '210 à 234 m', t: 'Manche ferme : trajectoire plus tendue et dispersion resserrée pour un swing rapide.' },
    { n: 'X-Stiff (X)', mph: '105 mph et plus', kmh: '169 km/h et plus', carry: '235 m et plus', t: 'Manche extra-ferme : réservé aux swings très rapides, au tempo vif et à la transition puissante.' }
  ];
  function flexIndexMph(mph) { return idx(mph, [75, 85, 95, 105]); }
  function flexIndexCarry(m) { return idx(m, [165, 185, 210, 235]); }
  function calcFlex(root) {
    var mode = val(root, 'mode') || 'speed', i, mph = NaN, txt;
    var speedBox = $(root, '[data-pg-mode="speed"]'), carryBox = $(root, '[data-pg-mode="carry"]');
    if (speedBox) speedBox.hidden = mode !== 'speed';
    if (carryBox) carryBox.hidden = mode !== 'carry';
    if (mode === 'carry') {
      var c = num(val(root, 'carry'));
      if (isNaN(c)) { show(root, '', ''); return; }
      if (c < 60 || c > 330) { show(root, '', 'Indiquez une distance de carry au driver entre 60 et 330 mètres.'); return; }
      i = flexIndexCarry(c); mph = 60 + (c - 120) / 2.4;
      txt = 'Distance de carry au driver : ' + fr(c) + ' m.';
    } else {
      var v = num(val(root, 'speed')), unit = val(root, 'unit') || 'mph';
      if (isNaN(v)) { show(root, '', ''); return; }
      mph = unit === 'kmh' ? v / 1.609 : v;
      if (mph < 40 || mph > 150) { show(root, '', 'Indiquez une vitesse de swing au driver entre 40 et 150 mph (65 à 240 km/h).'); return; }
      i = flexIndexMph(mph);
      txt = 'Vitesse de swing au driver : ' + fr(mph) + ' mph, soit ' + fr(mph * 1.609) + ' km/h.';
    }
    var f = FLEX[i];
    show(root, result({
      label: 'Flex conseillé',
      big: f.n,
      gauge: (mph - 60) / 60 * 100,
      marks: [[12, 'L'], [33, 'A'], [50, 'R'], [67, 'S'], [88, 'X']],
      kv: [['Vitesse', f.mph + ' (' + f.kmh + ')'], ['Carry au driver', f.carry]],
      p: [txt, f.t, 'Entre deux flex : le plus souple aide à monter la balle, le plus ferme resserre la dispersion. Un tempo rapide ou une transition brusque orientent vers le flex au-dessus.'],
      ctas: [['Voir les drivers', link(root, 'drivers', '/collections/drivers-de-golf')],
             ['Manches et grips', link(root, 'shafts', '/collections/grips-et-shafts')],
             [root.getAttribute('data-l-page') ? 'Guide du fitting' : '', link(root, 'page', '')]]
    }));
  }

  /* ---------- (c) Longueur de putter ----------
     Repères usuels taille → longueur : < 157 cm : 32 po ; 157-167 : 33 ; 168-177 : 34 ; 178-187 : 35 ; >= 188 : 36.
     Posture très penchée : un pouce de moins ; posture droite : un pouce de plus (bornes 32 à 36 po). */
  function putterLen(h, posture) {
    var base = 32 + idx(h, [157, 168, 178, 188]);
    if (posture === 'penche') base -= 1;
    if (posture === 'droit') base += 1;
    return Math.max(32, Math.min(36, base));
  }
  function calcPutt(root) {
    var h = num(val(root, 'h')), posture = val(root, 'posture') || 'standard';
    if (isNaN(h)) { show(root, '', ''); return; }
    if (h < 120 || h > 215) { show(root, '', 'Indiquez une taille entre 120 et 215 cm.'); return; }
    var L = putterLen(h, posture);
    show(root, result({
      label: 'Longueur de putter conseillée',
      big: L + ' pouces (' + cm(L) + ' cm)',
      p: ['À l\'adresse, vos yeux se placent à l\'aplomb de la balle ou juste à l\'intérieur, les bras pendent sans tension et la semelle repose à plat sur le green.',
          'Trop long, le putter relève la pointe et fait tirer la balle à gauche (pour un droitier) ; trop court, il vous fait plonger et la semelle touche par le talon.'],
      ctas: [['Voir les putters', link(root, 'putters', '/collections/putters')],
             ['Grips de putter', link(root, 'grips', '/collections/grips-de-putter')]]
    }));
  }

  /* ---------- Choix du putter ---------- */
  function calcPf(root) {
    var path = val(root, 'path'), vis = val(root, 'visual'), feel = val(root, 'feel'), hand = val(root, 'hand');
    var h = num(val(root, 'h'));
    var done = [path, vis, feel, hand].filter(Boolean).length;
    $$(root, '.pg-steps i').forEach(function (s, k) { s.classList.toggle('is-done', k < done); });
    if (!path || !vis || !feel || !hand) { show(root, '', ''); return; }
    var family, big, p = [];
    if (path === 'droite') {
      family = 'maillet'; big = 'Maillet face-balanced';
      p.push('Votre putter part et revient dans l\'axe : un modèle équilibré, face tournée vers le ciel quand on le pose en équilibre sur le doigt (face-balanced), garde la face square sans effort. Le maillet ajoute de la stabilité sur les coups décentrés.');
      if (vis === 'point') p.push('Vous préférez un visuel épuré ? Une lame à col central, elle aussi face-balanced, conviendra également.');
    } else if (path === 'legere') {
      if (vis === 'lignes') { family = 'maillet'; big = 'Maillet compact à léger toe hang'; }
      else { family = 'lame'; big = 'Lame à léger toe hang'; }
      p.push('Votre putter décrit un léger arc : un toe hang léger (pointe un peu tombante en équilibre) laisse la face s\'ouvrir puis se refermer naturellement avec l\'arc. Col en plongeur ou col court décalé.');
    } else {
      family = 'lame'; big = 'Lame à toe hang fort';
      p.push('Votre putter suit un arc marqué : un toe hang fort (pointe nettement tombante) accompagne la rotation de la face. Col en crochet ou col incliné.');
      if (vis === 'lignes') p.push('Ce profil existe aussi en petit maillet à toe hang marqué si vous aimez les lignes d\'alignement.');
    }
    p.push(feel === 'doux' ? 'Ressenti : une face à insert en polymère donne un toucher doux et une balle qui roule sans claquer, idéale sur des greens rapides.'
                           : 'Ressenti : une face en métal fraisé donne un son net et un retour précis de la distance, idéale sur des greens plus lents.');
    p.push(path === 'droite' ? 'Grip : un grip épais calme le jeu des poignets et stabilise la face.' : 'Grip : un grip standard ou fin conserve les sensations pour accompagner l\'arc.');
    var kv = [['Profil', big], ['Ressenti', feel === 'doux' ? 'Insert doux' : 'Métal fraisé']];
    if (!isNaN(h) && h >= 120 && h <= 215) kv.push(['Longueur indicative', putterLen(h, 'standard') + ' po (' + cm(putterLen(h, 'standard')) + ' cm)']);
    var ctas = [];
    if (hand === 'gaucher') ctas.push(['Putters gaucher', link(root, 'lefty', '/collections/putters-gaucher')]);
    ctas.push(family === 'maillet' ? ['Voir les putters maillet', link(root, 'mallet', '/collections/putters-maillet')] : ['Voir les putters lame', link(root, 'blade', '/collections/putters-lame')]);
    ctas.push(family === 'maillet' ? ['Putters lame', link(root, 'blade', '/collections/putters-lame')] : ['Putters maillet', link(root, 'mallet', '/collections/putters-maillet')]);
    ctas.push(['Grips de putter', link(root, 'grips', '/collections/grips-de-putter')]);
    show(root, result({ label: 'Votre profil de putter', big: big, kv: kv, p: p, ctas: ctas }));
  }

  /* ---------- Autonomie d'un chariot ----------
     Règle simple, calée sur les capacités couramment annoncées pour les batteries lithium 12 V de chariot
     (environ 16 Ah pour 18 trous, 22 Ah pour 27 trous, 28 Ah pour 36 trous sur parcours peu vallonné) :
     besoin = trous × 0,75 Ah × relief (plat 1 ; vallonné 1,2 ; très vallonné 1,4) × type (électrique 1 ; suiveur 1,25),
     + 10 % de marge à partir de 4 sorties par semaine (vieillissement plus rapide de la batterie).
     On retient la première capacité courante supérieure ou égale : 12, 16, 18, 22, 28, 36 Ah. */
  var AH = [12, 16, 18, 22, 28, 36];
  function calcBatt(root) {
    var holes = num(val(root, 'holes')) || 18, relief = val(root, 'relief') || 'plat', kind = val(root, 'kind') || 'electrique';
    var week = num(val(root, 'week')) || 2;
    var rf = { plat: 1, vallonne: 1.2, tres: 1.4 }[relief] || 1, kf = kind === 'suiveur' ? 1.25 : 1;
    var need = holes * 0.75 * rf * kf;
    if (week >= 4) need *= 1.1;
    var pick = null;
    for (var i = 0; i < AH.length; i++) { if (AH[i] >= need) { pick = AH[i]; break; } }
    var big = pick ? 'Batterie lithium 12 V de ' + pick + ' Ah' : 'Batterie lithium 12 V de 36 Ah et une seconde batterie';
    var reliefTxt = { plat: 'parcours plat', vallonne: 'parcours vallonné', tres: 'parcours très vallonné' }[relief];
    var p = ['Pour ' + holes + ' trous par sortie sur ' + reliefTxt + ' avec un chariot ' + (kind === 'suiveur' ? 'suiveur ou télécommandé' : 'électrique') + ', le besoin estimé est d\'environ ' + fr(need) + ' Ah.',
             'Rechargez après chaque sortie : avec ' + week + ' sortie' + (week > 1 ? 's' : '') + ' par semaine, comptez ' + week + ' recharge' + (week > 1 ? 's' : '') + ' par semaine. Une capacité un peu supérieure ménage la batterie et garde de la réserve en fin de partie.'];
    if (week >= 4) p.push('Usage intensif : une marge de 10 % est ajoutée pour compenser la perte de capacité au fil des cycles.');
    p.push('Le lithium est nettement plus léger que le plomb, se recharge plus vite et garde sa tension jusqu\'au bout de la partie. Vérifiez la compatibilité du connecteur avec votre chariot.');
    show(root, result({
      label: 'Capacité conseillée',
      big: big,
      kv: [['Trous par charge', String(holes)], ['Besoin estimé', '≈ ' + fr(need) + ' Ah'], ['Recharges par semaine', String(week)]],
      p: p,
      ctas: [['Batteries de chariot', link(root, 'batteries', '/collections/batteries-chariot-de-golf')],
             [kind === 'suiveur' ? 'Chariots suiveurs' : 'Chariots électriques', kind === 'suiveur' ? link(root, 'followers', '/collections/chariots-de-golf-suiveurs') : link(root, 'electric', '/collections/chariots-de-golf-electriques')]]
    }));
  }

  /* ---------- Voiturette : nombre de places ---------- */
  var USAGE = {
    golf: { min: 2, t: 'Sur le parcours, une voiturette 2 places transporte deux joueurs et leurs sacs ; elle reste compacte pour les chemins de golf. Au-delà de deux joueurs, passez à 4 places.' },
    domaine: { min: 4, t: 'Sur un domaine ou une propriété, 4 places permettent de déplacer famille, invités ou matériel, avec une banquette arrière souvent rabattable en plateau.' },
    residence: { min: 4, t: 'En résidence ou en complexe hôtelier, 4 places couvrent la plupart des trajets de clients et de personnel.' },
    camping: { min: 4, t: 'En camping ou en village de vacances, 4 places suffisent pour l\'accueil ; passez à 6 places pour les navettes de groupes.' },
    evenement: { min: 6, t: 'Pour l\'événementiel, les mariages et les grands sites, 6 places et plus limitent le nombre d\'allers-retours.' }
  };
  function calcCart(root) {
    var u = val(root, 'usage'), people = num(val(root, 'people')) || 2, terrain = val(root, 'terrain') || 'chemin';
    if (!u) { show(root, '', ''); return; }
    var info = USAGE[u] || USAGE.golf;
    var seats = Math.max(info.min, people <= 2 ? 2 : people <= 4 ? 4 : 6);
    var key = seats === 2 ? 'seats2' : seats === 4 ? 'seats4' : 'seats6';
    var defs = { seats2: '/collections/voiturettes-de-golf-2-places', seats4: '/collections/voiturettes-de-golf-4-places', seats6: '/collections/voiturettes-de-golf-6-places' };
    var p = [info.t];
    if (people > 6) p.push('Au-delà de 6 personnes, prévoyez deux voiturettes ou un modèle 8 places.');
    if (terrain === 'accidente') p.push('Terrain accidenté, herbe haute ou chemins de terre : choisissez un modèle tout-terrain (garde au sol relevée, pneus à crampons, suspensions renforcées).');
    p.push('Batterie : le lithium est plus léger, sans entretien, se recharge plus vite et garde sa puissance dans les montées ; le plomb coûte moins cher à l\'achat mais demande un entretien régulier et pèse plus lourd.');
    var ctas = [['Voiturettes ' + seats + (seats === 6 ? ' places et plus' : ' places'), link(root, key, defs[key])]];
    if (terrain === 'accidente') ctas.push(['Voiturettes tout-terrain', link(root, 'offroad', '/collections/voiturettes-de-golf-tout-terrain')]);
    ctas.push(['Batteries lithium', link(root, 'cartbatt', '/collections/batteries-voiturette-de-golf')]);
    show(root, result({
      label: 'Voiturette conseillée',
      big: (seats === 6 ? '6 places et plus' : seats + ' places') + (terrain === 'accidente' ? ', tout-terrain' : ''),
      kv: [['Personnes à transporter', String(people)], ['Usage', ({ golf: 'Parcours de golf', domaine: 'Domaine ou propriété', residence: 'Résidence, hôtel', camping: 'Camping', evenement: 'Événementiel' })[u]]],
      p: p,
      ctas: ctas
    }));
  }

  /* ---------- Balle selon la vitesse de swing ----------
     Repères usuels : moins de 85 mph = balle 2 pièces à faible compression ; 85 à 104 mph = 3 pièces ;
     105 mph et plus = 3 ou 4 pièces à enrobage uréthane (plus d'effet au petit jeu). */
  function calcBall(root) {
    var v = num(val(root, 'speed')), unit = val(root, 'unit') || 'mph';
    if (isNaN(v)) { show(root, '', ''); return; }
    var mph = unit === 'kmh' ? v / 1.609 : v;
    if (mph < 40 || mph > 150) { show(root, '', 'Indiquez une vitesse de swing au driver entre 40 et 150 mph (65 à 240 km/h).'); return; }
    var big, p;
    if (mph < 85) { big = 'Balle 2 pièces, faible compression'; p = ['Un noyau souple se comprime facilement avec un swing posé : plus de distance, une trajectoire haute et moins d\'effet latéral sur les coups manqués.']; }
    else if (mph < 105) { big = 'Balle 3 pièces'; p = ['Une couche intermédiaire ajoute du contrôle autour du green sans sacrifier la distance : le meilleur compromis pour un swing moyen à rapide.']; }
    else { big = 'Balle 3 ou 4 pièces, enrobage uréthane'; p = ['Votre vitesse comprime pleinement un noyau ferme : l\'enrobage uréthane donne de l\'effet rétro au petit jeu et un toucher précis au putting.']; }
    p.push('Vitesse retenue : ' + fr(mph) + ' mph (' + fr(mph * 1.609) + ' km/h). Testez deux modèles sur vos approches : c\'est autour du green que la différence se voit le plus.');
    show(root, result({ label: 'Balle conseillée', big: big, p: p, ctas: [['Voir les balles de golf', link(root, 'balls', '/collections/balles-de-golf')]] }));
  }

  var CALCS = { len: calcLen, flex: calcFlex, putt: calcPutt, pf: calcPf, batt: calcBatt, cart: calcCart, ball: calcBall };

  function initCalc(root) {
    if (root.__pg) return; root.__pg = true;
    var fn = CALCS[root.getAttribute('data-pg-calc')];
    if (!fn) return;
    var run = function () { try { fn(root); } catch (e) { /* aucun blocage de la page */ } };
    root.addEventListener('input', run);
    root.addEventListener('change', run);
    root.addEventListener('submit', function (e) { e.preventDefault(); run(); });
    // Calcul immédiat quand des valeurs par défaut sont présentes (batterie, voiturette)
    if (root.hasAttribute('data-pg-auto')) run();
  }

  /* ---------- Onglets ---------- */
  function initTabs(box) {
    if (box.__pg) return; box.__pg = true;
    var tabs = $$(box, '[role="tab"]');
    function activate(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t, panel = document.getElementById(x.getAttribute('aria-controls'));
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        if (panel) panel.hidden = !on;
      });
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        else if (k === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (k === 'Home') n = tabs[0];
        else if (k === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); activate(n, true); }
      });
    });
    var start = null, hash = (location.hash || '').replace('#', '');
    if (hash) tabs.forEach(function (t) { if (t.getAttribute('data-pg-hash') === hash) start = t; });
    if (!start) tabs.forEach(function (t) { if (t.hasAttribute('data-pg-default')) start = t; });
    activate(start || tabs[0]);
  }

  /* ---------- Vidéos d'ambiance (ouverture, bandeau) ----------
     Chargées après la page, jamais sous « réduire les animations » ni en mode économie de données : l'image d'attente reste. */
  function initVideo(box) {
    if (box.__pg) return; box.__pg = true;
    var v = $(box, 'video[data-src-desktop]');
    if (!v || REDUCE || (navigator.connection && navigator.connection.saveData)) return;
    function start() {
      var mobile = window.matchMedia('(max-width: 767px)').matches; // 720p sous 768 px, 1080p au-delà
      var src = (mobile && v.getAttribute('data-src-mobile')) || v.getAttribute('data-src-desktop');
      if (!src) return;
      v.src = src;
      v.addEventListener('playing', function () { box.classList.add('is-playing'); }, { once: true });
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); setTimeout(start, 150); } }, { rootMargin: '200px' });
      if (document.readyState === 'complete') io.observe(box); else window.addEventListener('load', function () { io.observe(box); });
    } else { window.addEventListener('load', start); }
  }

  /* ---------- Parcours : flèches de défilement ---------- */
  function initCourse(box) {
    if (box.__pg) return; box.__pg = true;
    var sc = $(box, '.pg-course__scroller');
    if (!sc) return;
    $$(box, '[data-pg-dir]').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = $(sc, '.pg-hole'), step = card ? card.getBoundingClientRect().width + 22 : 300;
        sc.scrollBy({ left: step * parseInt(b.getAttribute('data-pg-dir'), 10), behavior: REDUCE ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- Révélation au défilement ---------- */
  var revealer = null;
  function initReveal(scope) {
    var els = $$(scope, '.pg-reveal:not(.is-in), .pg-course:not(.is-in)');
    if (!els.length) return;
    if (REDUCE || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    if (!revealer) revealer = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); revealer.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { revealer.observe(e); });
  }

  function init(scope) {
    scope = scope || document;
    $$(scope, '[data-pg-calc]').forEach(initCalc);
    $$(scope, '[data-pg-tabs]').forEach(initTabs);
    $$(scope, '[data-pg-video]').forEach(initVideo);
    $$(scope, '[data-pg-course]').forEach(initCourse);
    initReveal(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  // Éditeur de thème : une section rechargée est réinitialisée
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.PutterGolf = { init: init };
})();
